import React from "react";
import ListPage from "./ListPage";

const money = (n) => (n == null ? "" : Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const P = (o) => o; // stable param objects (avoid refetch on re-render)

const PARTY_PARAMS = P({ role: "customer", page_size: 200 });
const PARTY_COLS = [
  { label: "Code", value: (r) => r.code },
  { label: "Name", value: (r) => r.display_name || r.name },
  { label: "Phone", value: (r) => r.phone || r.mobile },
  { label: "Active", value: (r) => (r.is_active === false ? "No" : "Yes") },
];
export const PartiesList = () => (
  <ListPage testid="parties-list" cacheKey="parties" title="Customers" path="/parties/" params={PARTY_PARAMS} columns={PARTY_COLS} />
);

const PRODUCT_PARAMS = P({ limit: 500 });
const PRODUCT_COLS = [
  { label: "SKU", value: (r) => r.sku },
  { label: "Name", value: (r) => r.name },
  { label: "UoM", value: (r) => r.uom },
  { label: "Active", value: (r) => (r.is_active ? "Yes" : "No") },
];
export const ProductsList = () => (
  <ListPage testid="products-list" cacheKey="products" title="Products" path="/inventory/products" params={PRODUCT_PARAMS} columns={PRODUCT_COLS} />
);

const STOCK_PARAMS = P({ limit: 1000 });
const STOCK_COLS = [
  { label: "SKU", value: (r) => r.product_sku },
  { label: "Product", value: (r) => r.product_name },
  { label: "Warehouse", value: (r) => r.warehouse_name },
  { label: "Qty", value: (r) => r.quantity },
];
export const StockList = () => (
  <ListPage testid="stock-list" cacheKey="stock" title="Stock" path="/inventory/stock" params={STOCK_PARAMS}
    columns={STOCK_COLS} rowKey="_k" unwrap={(d) => d.map((r) => ({ ...r, _k: `${r.product_id}:${r.warehouse_id}` }))} />
);

const DOC_PARAMS = P({ page_size: 200 });
const DOC_COLS = [
  { label: "Number", value: (r) => r.number || "(draft)" },
  { label: "Date", value: (r) => r.document_date },
  { label: "Customer", value: (r) => r.customer?.name },
  { label: "Status", value: (r) => r.state },
  { label: "Total", value: (r) => money(r.totals?.total) },
];
export const InvoicesList = () => (
  <ListPage testid="invoices-list" cacheKey="invoices" title="Sales invoices" path="/sales/invoices" params={DOC_PARAMS} columns={DOC_COLS} />
);

const ORDER_COLS = [
  { label: "Number", value: (r) => r.number || "(draft)" },
  { label: "Date", value: (r) => r.document_date },
  { label: "Status", value: (r) => r.state },
  { label: "Source", value: (r) => r.source },
];
export const OrdersList = () => (
  <ListPage testid="orders-list" cacheKey="orders" title="Orders" path="/orders/" params={DOC_PARAMS} columns={ORDER_COLS} />
);
